<!--<template>-->
<!--&lt;!&ndash;  <LayoutError></LayoutError>&ndash;&gt;-->
<!--</template>-->

<!--<script setup lang="ts">-->

<!--</script>-->
<!--<style lang="scss">-->
<!--</style>-->
<script setup lang="ts">
const props = defineProps({
  error: {type: Object}
})
</script>

<template>
  <NuxtLayout name="main">
    <div class="not-found-page">
      <div class="centered" v-if="error!.statusCode === 404">
        <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>404</h1>
        <p>Die gesuchte Seite konnte leider nicht gefunden werden</p>
      </div>
      <div class="centered" v-if="error!.statusCode === 401">
        <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>401</h1>
        <p>Ihnen fehlen die notwendigen Berechtigungen, um diese Seite anzuzeigen.</p>
      </div>
      <div class="centered" v-if="error!.statusCode !== 404 && error!.statusCode !== 401">
        <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>Fehler</h1>
        <p>Es ist ein unbekannter Fehler aufgetreten: {{ error!.message }}</p>
      </div>
    </div>
  </NuxtLayout>
</template>

<style scoped lang="scss">

.not-found-page {
  .full-page > .content,
  .centered {
    min-height: calc(100vh - 160px);
  }

  .not-found-icon {
    margin-right: 10px;
  }

  .centered {
    h1,
    i {
      font-size: 50px;
    }

    p {
      font-size: 20px;
    }

    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
  }
}
</style>